import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Search } from "lucide-react";

/**
 * UnifiedSearch — one input, three destination page types.
 * Property (address) · Program (population/vertical) · Place (ZIP or city).
 */
export default function UnifiedSearch() {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const go = async (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.get(`/search/entity`, { params: { q: q.trim() } });
      if (data.type === "none") nav(`/place/${encodeURIComponent(q.trim())}`);
      else nav(data.route);
    } finally { setBusy(false); }
  };

  return (
    <form onSubmit={go} className="relative w-full max-w-lg" role="search" aria-label="Unified search">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
      <input
        value={q} onChange={e=>setQ(e.target.value)}
        placeholder="Address · population · ZIP…"
        className="w-full h-10 pl-9 pr-16 border border-slate-200 rounded-md bg-white text-sm focus:outline-none focus:ring-2 focus:ring-slate-900"
        data-testid="unified-search-input"
      />
      <button type="submit" disabled={busy} className="absolute right-1 top-1 bottom-1 px-3 rounded bg-slate-900 hover:bg-slate-800 text-white text-xs font-semibold" data-testid="unified-search-submit">
        {busy ? "…" : "Go"}
      </button>
    </form>
  );
}
